import { useSyncExternalStore } from 'react';
import AppDataManager from '../calling-cross-tab-utils/AppDataManager';
import { ConnectionStatusTypes } from 'shared-worker-versioning/lib/types/ConnectionStatuses';
import { createUpdateWidgetDetailsMessage, createUpdateCallSettingsMessage, createResetActiveCallDetailsMessage } from 'calling-cross-tab-library/messages/ToWorkerMessages';
import CrossTabConfig from '../calling-cross-tab-utils/CrossTabConfig';
import WorkerConnection from '../WorkerConnection';
const canSendMessage = connectionStatus => [ConnectionStatusTypes.FAILED, ConnectionStatusTypes.UNSUPPORTED].includes(connectionStatus) === false;
export const updateWidgetDetails = message => {
  const widgetDetailsMessage = createUpdateWidgetDetailsMessage({
    widgetDetails: message,
    originConnectionId: CrossTabConfig.get().connectionId
  });
  const connectionStatus = AppDataManager.getConnectionStatus();
  if (canSendMessage(connectionStatus)) {
    WorkerConnection.sendMessage(widgetDetailsMessage);
    return Promise.resolve();
  }
  return Promise.reject(new Error(`Unable to send message with status ${connectionStatus}`));
};
export const useWidgetDetails = () => {
  const appData = useSyncExternalStore(AppDataManager.subscribeToAppData, AppDataManager.getAppData);
  const widgetDetails = appData.widgetDetails;
  return {
    widgetDetails
  };
};
export const useCallSettings = () => {
  const appData = useSyncExternalStore(AppDataManager.subscribeToAppData, AppDataManager.getAppData);
  const widgetDetails = appData.widgetDetails;
  const callSettings = {
    connectFromNumbers: widgetDetails.connectFromNumbers,
    externalFromNumbers: widgetDetails.externalFromNumbers,
    portalFromNumbers: widgetDetails.portalFromNumbers,
    hasCallingAccess: widgetDetails.hasCallingAccess,
    isHubSpotCallingEnabled: widgetDetails.isHubSpotCallingEnabled,
    isRecordingEnabled: widgetDetails.isRecordingEnabled,
    isPaidHub: widgetDetails.isPaidHub,
    callReceivingPreference: widgetDetails.callReceivingPreference,
    callingLimit: widgetDetails.callingLimit,
    callDispositions: widgetDetails.callDispositions,
    callTypes: widgetDetails.callTypes,
    defaultTaskSettings: widgetDetails.defaultTaskSettings,
    installedCallingSettings: widgetDetails.installedCallingSettings,
    isCallOutcomeRequired: widgetDetails.isCallOutcomeRequired
  };
  return callSettings;
};
export const updateCallSettings = message => {
  const callSettingsMessage = createUpdateCallSettingsMessage({
    callSettings: message,
    originConnectionId: CrossTabConfig.get().connectionId
  });
  const connectionStatus = AppDataManager.getConnectionStatus();
  if (canSendMessage(connectionStatus)) {
    WorkerConnection.sendMessage(callSettingsMessage);
    return Promise.resolve();
  }
  return Promise.reject(new Error(`Unable to send message with status ${connectionStatus}`));
};
export const resetActiveCallDetailsAndCallStatus = () => {
  const resetWidgetDetailsMessage = createResetActiveCallDetailsMessage(CrossTabConfig.get().connectionId);
  const connectionStatus = AppDataManager.getConnectionStatus();
  if (canSendMessage(connectionStatus)) {
    WorkerConnection.sendMessage(resetWidgetDetailsMessage);
    return Promise.resolve();
  }
  return Promise.reject(new Error(`Unable to send message with status ${connectionStatus}`));
};
export const resetStandaloneConnection = () => {
  const widgetDetailsMessage = createUpdateWidgetDetailsMessage({
    originConnectionId: CrossTabConfig.get().connectionId,
    widgetDetails: {
      standaloneConnectionId: undefined
    }
  });
  const connectionStatus = AppDataManager.getConnectionStatus();
  if (canSendMessage(connectionStatus)) {
    WorkerConnection.sendMessage(widgetDetailsMessage);
    return Promise.resolve();
  }
  return Promise.reject(new Error(`Unable to send message with status ${connectionStatus}`));
};